SmartTweens = {
  tweens: [],

  // initialise() {
  //   //Reflex.registerEventHandler("layoutChange", this.recalculate.bind(this));
  // },

  tween(fromObj, toObj, fromObjPosFrom = undefined, props = {}, useVisualCenter = true) {
    let resolveFn;
    const promise = new Promise((res) => (resolveFn = res));

    const entry = {};
    const { x, y, ...gsapProps } = props;
    const makeTween = () =>
      gsap.to(fromObj, {
        ...gsapProps,
        overwrite: false,
        ...(x !== false && {
          x: () =>
            helper.getLocalFromGlobalPosition(toObj, fromObjPosFrom ? fromObjPosFrom : fromObj, useVisualCenter).x,
        }),
        ...(y !== false && {
          y: () =>
            helper.getLocalFromGlobalPosition(toObj, fromObjPosFrom ? fromObjPosFrom : fromObj, useVisualCenter).y,
        }),
        onComplete: () => {
          if (entry.completed) return;
          entry.completed = true;
          resolveFn();
          this._removeEntry(entry);
        },
      });

    const tween = makeTween();

    entry.fromObj = fromObj;
    entry.toObj = toObj;
    entry.fromObjPosFrom = fromObjPosFrom;
    entry.props = props;
    entry.useVisualCenter = useVisualCenter;
    entry.tween = tween;
    entry.resolveFn = resolveFn;
    entry.makeTween = makeTween;
    entry.promise = promise;
    entry.recalculateOnOrientation = true;
    entry.completed = false;

    this.tweens.push(entry);

    return promise;
  },

  timeline(makeTimeline) {
    let resolveFn;
    const promise = new Promise((res) => (resolveFn = res));

    const entry = {};

    const tl = makeTimeline();

    tl.eventCallback("onComplete", () => {
      if (entry.completed) return;
      entry.completed = true;
      resolveFn();
      this._removeEntry(entry);
    });

    entry.tween = tl;
    entry.promise = promise;
    entry.recalculateOnOrientation = false;
    entry.completed = false;

    this.tweens.push(entry);

    return promise;
  },

  recalculate() {
    this.tweens.forEach((entry) => {
      if (!entry.recalculateOnOrientation) return;

      const { tween, makeTween } = entry;

      if (!tween || !makeTween) return;

      entry.tween.invalidate();
    });
  },

  skipAll() {
    const activeTweens = [...this.tweens];

    activeTweens.forEach((entry) => {
      const tween = entry.tween;

      if (tween && tween.progress() < 1) {
        tween.eventCallback("onStart", null);
        tween.progress(1);
      }
    });
  },

  _removeEntry(entry) {
    const index = this.tweens.indexOf(entry);
    if (index !== -1) {
      this.tweens.splice(index, 1);
    }
  },
};
